/* Nimbuz theme — vanilla JS, no dependencies */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = window.nimbus || { routes: {}, moneyFormat: '{{amount}}', strings: {} };
  const reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)').matches : false;

  /* ---------- Money ---------- */
  const money = (cents) => {
    const fmt = cfg.moneyFormat || '₹{{amount}}';
    const n = cents / 100;
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    let out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(n).toLocaleString('en-IN'); break;
      case 'amount_with_comma_separator': out = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      default: out = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]+>/g, '');
  };

  /* ---------- Toast ---------- */
  const toast = $('[data-toast]');
  let toastTimer;
  const showToast = (msg) => {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-show'), 2800);
  };

  /* ---------- Cart count ---------- */
  const setCartCount = (n) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.classList.add('is-bump');
      setTimeout(() => el.classList.remove('is-bump'), 300);
    });
    $$('[data-cart-btn]').forEach((b) => b.setAttribute('aria-label', `Cart, ${n} items`));
  };

  const addToCart = async (variantId, quantity, properties) => {
    const body = { id: Number(variantId), quantity: Number(quantity) || 1 };
    if (properties) body.properties = properties;
    const res = await fetch(cfg.routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    setCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: body.id, qty: body.quantity, cart } }));
    return { line: data, cart };
  };

  /* ---------- Header: mobile nav + search ---------- */
  try {
    const nav = $('[data-nav]');
    const menuToggle = $('[data-menu-toggle]');
    if (menuToggle && nav) {
      menuToggle.addEventListener('click', (e) => {
        const open = nav.classList.toggle('is-open');
        e.currentTarget.setAttribute('aria-expanded', open);
      });
    }
    const searchPanel = $('[data-search-panel]');
    $$('[data-search-toggle]').forEach((b) => b.addEventListener('click', () => {
      if (!searchPanel) return;
      const open = searchPanel.hasAttribute('hidden');
      searchPanel.toggleAttribute('hidden', !open);
      $$('[data-search-toggle]').forEach((x) => x.setAttribute('aria-expanded', open));
      if (open) $('[data-search-input]')?.focus();
    }));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && searchPanel && !searchPanel.hasAttribute('hidden')) searchPanel.setAttribute('hidden', ''); });
  } catch(e) { if (console && console.error) console.error('Header init error:', e); }

  /* ---------- Product section ---------- */
  $$('[data-product-section]').forEach((section) => {
    if (section.dataset.productInit) return;
    section.dataset.productInit = '1';
    try {
    const jsonEl = $('[data-product-json]', section) || $('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', section);
    const variantInput = $('[data-variant-id]', section);
    const qtyInput = $('[data-qty-input]', section);
    const atcBtn = $('[data-add-to-cart]', section);
    const atcLabel = $('[data-atc-label]', section);
    const atcPrice = $('[data-atc-price]', section);
    const priceNow = $('[data-price-now]', $('.buybox__price', section) || section);
    const priceCompare = $('[data-price-compare]', $('.buybox__price', section) || section);
    const stock = $('[data-stock]', section);
    const stickyPrice = $('[data-sticky-price]');
    const stickyLabel = $('[data-sticky-label]');
    const stickyAdd = $('[data-sticky-add]');
    const mainImg = $('[data-gallery-main]', section);
    const thumbs = $$('.thumb', section);
    const showPriceInBtn = atcPrice && atcPrice.textContent.trim() !== '';

    let variant = product.variants.find((v) => String(v.id) === String(variantInput?.value)) || product.variants[0];
    const qty = () => Math.max(1, Number(qtyInput?.value) || 1);

    /* Pack offers: each card is a quantity; price tiers mirror the automatic discount in admin */
    const packWrap = $('[data-pack-offers]', section);
    const packRadios = packWrap ? $$('input[type=radio]', packWrap) : [];
    const tierQty = Number(packWrap?.dataset.tierQty) || 0;
    const tierOff = Number(packWrap?.dataset.tierOff) || 0;
    const unitPrice = (q) => (variant ? (tierQty && q >= tierQty ? Math.max(0, variant.price - tierOff) : variant.price) : 0);
    const lineTotal = (q) => unitPrice(q) * q;

    /* Gallery: image/video switching is owned by snippets/product-gallery.liquid (window.nbGallerySelect). */
    const activateThumb = (t) => {
      if (!t || !mainImg) return;
      if (window.nbGallerySelect) { window.nbGallerySelect(t); return; }
      thumbs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
      mainImg.classList.add('is-fading');
      setTimeout(() => {
        mainImg.src = t.dataset.src;
        if (t.dataset.srcset) mainImg.srcset = t.dataset.srcset;
        mainImg.alt = t.dataset.alt || '';
        mainImg.classList.toggle('is-contain', t.dataset.fit === 'contain');
        mainImg.onload = () => mainImg.classList.remove('is-fading');
      }, 160);
    };
    const galleryEl = $('[data-gallery]', section);
    if (!galleryEl || !galleryEl.dataset.galleryBound) {
      thumbs.forEach((t) => t.addEventListener('click', () => { if (!t.classList.contains('is-active')) activateThumb(t); }));
    }

    /* Render */
    const render = () => {
      const available = variant && variant.available;
      const q = qty();
      if (variantInput && variant) variantInput.value = variant.id;
      if (priceNow && variant) priceNow.textContent = money(lineTotal(q));
      if (priceCompare && variant) {
        const discountedUnit = unitPrice(q);
        const compareBase =
          variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price
            : discountedUnit < variant.price
              ? variant.price
              : null;
        priceCompare.textContent = compareBase ? money(compareBase * q) : '';
        priceCompare.toggleAttribute('hidden', !compareBase);
        priceCompare.closest('.price')?.classList.toggle('price--sale', !!compareBase);
      }
      if (atcBtn) {
        atcBtn.disabled = !available;
        if (atcLabel) atcLabel.textContent = !variant ? cfg.strings.unavailable : available ? (atcLabel.dataset.label || (atcLabel.dataset.label = atcLabel.textContent)) : cfg.strings.soldOut;
        if (atcPrice) atcPrice.textContent = available && showPriceInBtn ? `— ${money(lineTotal(q))}` : '';
      }
      if (stickyPrice && variant) stickyPrice.textContent = money(lineTotal(q));
      const stickyCompare = $('[data-sticky-compare]');
      const stickySave = $('[data-sticky-save]');
      if (stickyCompare && variant) {
        const scUnit = unitPrice(q);
        const scBase = variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : scUnit < variant.price ? variant.price : null;
        const total = lineTotal(q);
        stickyCompare.textContent = scBase ? money(scBase * q) : '';
        stickyCompare.toggleAttribute('hidden', !scBase);
        if (stickySave) {
          stickySave.textContent = scBase ? `${Math.round(((scBase * q - total) * 100) / (scBase * q))}% OFF` : '';
          stickySave.toggleAttribute('hidden', !scBase);
        }
      }
      packRadios.forEach((r) => { r.checked = Number(r.value) === q; r.closest('.offer')?.classList.toggle('is-selected', r.checked); });
      if (stickyLabel && variant) stickyLabel.textContent = `${product.title}${variant.title !== 'Default Title' ? ' · ' + variant.title : ''}${q > 1 ? ' × ' + q : ''}`;
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        /* Update only the label span so the inline payment logos (GPay / PhonePe / Paytm) stay inside the button */
        const stickyText = stickyAdd.querySelector('[data-sticky-label-text]');
        if (stickyText) {
          if (!stickyText.dataset.label) stickyText.dataset.label = stickyText.textContent.trim() || 'BUY NOW — CASH ON DELIVERY';
          stickyText.textContent = available ? stickyText.dataset.label : cfg.strings.soldOut;
        } else {
          stickyAdd.textContent = available ? cfg.strings.addToCart : cfg.strings.soldOut;
        }
      }
      if (stock) stock.classList.toggle('is-out', !available);
      if (variant && history.replaceState && section.hasAttribute('data-update-url')) {
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      }
      if (variant && variant.featured_media) {
        const t = thumbs.find((x) => String(x.dataset.mediaId) === String(variant.featured_media.id));
        if (t && !t.classList.contains('is-active')) activateThumb(t);
      }
    };

    /* Variant picker */
    const radios = $$('[data-variant-picker] input[type=radio]', section);
    radios.forEach((r) => r.addEventListener('change', () => {
      const picks = [];
      $$('[data-variant-picker] fieldset', section).forEach((fs) => { const c = $('input:checked', fs); picks.push(c ? c.value : null); });
      variant = product.variants.find((v) => v.options.every((o, i) => o === picks[i])) || null;
      render();
    }));

    /* Pack offers */
    packRadios.forEach((r) => r.addEventListener('change', () => {
      if (!r.checked) return;
      if (qtyInput) qtyInput.value = Math.min(99, Math.max(1, Number(r.value) || 1));
      render();
    }));
    const checkedPack = packRadios.find((r) => r.checked);
    if (checkedPack && qtyInput && Number(qtyInput.value) !== Number(checkedPack.value)) qtyInput.value = checkedPack.value;

    /* Quantity */
    $$('[data-qty]', section).forEach((b) => b.addEventListener('click', (e) => {
      e.preventDefault();
      if (!qtyInput) return;
      const delta = parseInt(b.dataset.qty, 10) || 0;
      const current = parseInt(qtyInput.value, 10) || 1;
      const next = Math.min(99, Math.max(1, current + delta));
      qtyInput.value = next;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    }));
    qtyInput?.addEventListener('change', render);
    qtyInput?.addEventListener('input', () => { const v = parseInt(qtyInput.value, 10); if (v && v > 0) render(); });

    /* Gallery lightbox: click main image to view full-size */
    const zoomImg = $('[data-gallery-zoom]', section);
    if (zoomImg) {
      zoomImg.style.cursor = 'zoom-in';
      zoomImg.addEventListener('click', () => {
        const src = zoomImg.src;
        const overlay = document.createElement('div');
        overlay.className = 'lightbox';
        overlay.innerHTML = `<img src="${src}" alt="">`;
        overlay.addEventListener('click', () => { overlay.classList.remove('is-open'); setTimeout(() => overlay.remove(), 300); });
        document.body.appendChild(overlay);
        requestAnimationFrame(() => overlay.classList.add('is-open'));
      });
    }

    /* Add to cart (AJAX with graceful fallback) */
    const errEl = $('[data-form-error]', section);
    const submit = async () => {
      if (!variant || !variant.available) return;
      atcBtn?.classList.add('is-loading');
      try {
        await addToCart(variant.id, qty());
        showToast(`${cfg.strings.added}: ${product.title}${variant.title !== 'Default Title' ? ' · ' + variant.title : ''} × ${qty()}`);
        errEl && (errEl.hidden = true);
        window.location.href = cfg.routes.cart_url || '/cart';
      } catch (err) {
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else { showToast(err.message); }
      } finally { atcBtn?.classList.remove('is-loading'); }
    };
    form?.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    stickyAdd?.addEventListener('click', submit);

    /* Sticky bar visibility */
    const bar = $('[data-sticky-bar]');
    /* Anchor on the main Add-to-cart button: the bar slides in as soon as the button scrolls above the viewport */
    const buybox = $('[data-add-to-cart]', section) || $('#buybox', section);
    if (bar && buybox && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(buybox);
    }

    /* Share */
    $('[data-share]', section)?.addEventListener('click', async (e) => {
      const { title, url } = e.currentTarget.dataset;
      if (navigator.share) { try { await navigator.share({ title, url }); } catch (_) { /* cancelled */ } }
      else { await navigator.clipboard?.writeText(url); showToast('Link copied'); }
    });

    render();
    } catch(e) { if (console && console.error) console.error('Product section init error:', e); }
  });
  $$('[data-ajax-add]').forEach((f) => f.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = $('button', f);
    btn?.classList.add('is-loading');
    try {
      const { line } = await addToCart(f.id.value, f.quantity.value);
      showToast(`${cfg.strings.added}: ${line.product_title}`);
      window.location.href = cfg.routes.cart_url || '/cart';
    } catch (err) { showToast(err.message); }
    finally { btn?.classList.remove('is-loading'); }
  }));

  /* ---------- Dynamic checkout button: relabel Shopify's "Buy it now" ---------- */
  /* Shopify renders the unbranded button asynchronously and re-renders it on variant / state changes,
     so we watch each wrapper and re-apply the merchant's label whenever the text is reset. */
  const relabelDynamicCheckout = (root = document) => {
    $$('[data-dynamic-checkout]', root).forEach((wrap) => {
      const label = (wrap.dataset.dynamicLabel || '').trim();
      if (!label || wrap.dataset.relabelInit) return;
      wrap.dataset.relabelInit = '1';
      const apply = () => {
        $$('.shopify-payment-button__button--unbranded, button[data-testid="Checkout-button"]', wrap).forEach((btn) => {
          if (btn.textContent.trim() !== label) btn.textContent = label;
          btn.setAttribute('aria-label', label);
        });
      };
      apply();
      new MutationObserver(apply).observe(wrap, { childList: true, subtree: true, characterData: true });
    });
  };
  relabelDynamicCheckout();
  document.addEventListener('shopify:section:load', (e) => relabelDynamicCheckout(e.target));

  /* ---------- Cart page ---------- */
  try {
    const cartSection = $('[data-cart-section]');
    if (cartSection) {
      let busy = false;
      const changeLine = async (line, quantity) => {
        if (busy) return; busy = true;
        cartSection.classList.add('is-busy');
        try {
          const res = await fetch(cfg.routes.cart_change_url || '/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity })
          });
          if (!res.ok) throw new Error('Could not update cart');
          location.reload();
        } catch (err) { showToast(err.message); busy = false; cartSection.classList.remove('is-busy'); }
      };
      $$('[data-line]', cartSection).forEach((row) => {
        const line = Number(row.dataset.line);
        const input = $('[data-line-input]', row);
        $$('[data-line-qty]', row).forEach((b) => b.addEventListener('click', () => {
          const next = Math.max(0, Number(input.value) + Number(b.dataset.lineQty));
          changeLine(line, next);
        }));
        input?.addEventListener('change', () => changeLine(line, Math.max(0, Number(input.value))));
        $('[data-line-remove]', row)?.addEventListener('click', (e) => { e.preventDefault(); changeLine(line, 0); });
      });
      $('textarea[name=note]', cartSection)?.addEventListener('change', (e) => {
        fetch(cfg.routes.cart_update_url || '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
      });
    }
  } catch(e) { if (console && console.error) console.error('Cart init error:', e); }

  /* ---------- Collection sort ---------- */
  try { $('[data-sort-select]')?.addEventListener('change', (e) => e.target.form.submit()); } catch(e) {}

  /* ---------- Account helpers ---------- */
  try {
    $$('[data-recover-toggle]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      const panel = $('[data-recover-panel]'); const login = $('#CustomerLogin');
      const show = panel.hasAttribute('hidden');
      panel.toggleAttribute('hidden', !show); login.toggleAttribute('hidden', show);
    }));
    $$('[data-address-toggle]').forEach((b) => b.addEventListener('click', () => {
      const el = document.getElementById(b.dataset.addressToggle); el?.toggleAttribute('hidden');
    }));
    $$('[data-country-select]').forEach((sel) => { if (sel.dataset.default) sel.value = sel.dataset.default; });
    $$('[data-confirm]').forEach((b) => b.addEventListener('click', (e) => { if (!confirm(b.dataset.confirm)) e.preventDefault(); }));
  } catch(e) { if (console && console.error) console.error('Account init error:', e); }

  /* ---------- Helpful votes (local only) ---------- */
  try {
    $$('[data-helpful]').forEach((b) => b.addEventListener('click', () => {
      const n = b.querySelector('b'); const on = b.classList.toggle('is-on');
      if (n) n.textContent = Number(n.textContent) + (on ? 1 : -1);
    }));
  } catch(e) {}

  /* ---------- One-open accordions ---------- */
  try {
    $$('[data-accordion]').forEach((acc) => {
      $$('details', acc).forEach((d) => d.addEventListener('toggle', () => {
        if (d.open) $$('details', acc).forEach((x) => { if (x !== d) x.open = false; });
      }));
    });
  } catch(e) {}



  /* ---------- Review photos: strip at the top of a reviews section + popup viewer ---------- */
  const reviewPhotos = (() => {
    const svgArrow = (flip) => `<svg class="ico${flip ? ' flip' : ''}" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>`;
    const svgClose = `<svg class="ico" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>`;
    let lb = null, items = [], idx = 0, lastFocus = null;

    const infoOf = (card) => {
      const img = card.querySelector('.review__photo');
      const stars = card.querySelector('.stars');
      const meta = card.querySelector('footer div span');
      return {
        card,
        thumb: img ? img.currentSrc || img.src : '',
        full: img ? (img.dataset.full || img.src) : '',
        alt: img ? img.alt : '',
        stars: stars ? stars.outerHTML : '',
        verified: !!card.querySelector('.verified'),
        title: (card.querySelector('h3') || {}).textContent || '',
        text: (card.querySelector(':scope > p') || {}).textContent || '',
        name: (card.querySelector('footer strong') || {}).textContent || 'Customer',
        meta: meta ? meta.textContent : ''
      };
    };

    const ensureLightbox = () => {
      if (lb) return lb;
      lb = document.createElement('div');
      lb.className = 'rlb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Customer photo'); lb.hidden = true;
      lb.innerHTML = `
        <button type="button" class="rlb__close" data-rlb-close aria-label="Close">${svgClose}</button>
        <button type="button" class="rlb__arrow rlb__arrow--prev" data-rlb-prev aria-label="Previous photo">${svgArrow(true)}</button>
        <div class="rlb__panel" data-rlb-panel>
          <div class="rlb__media"><img data-rlb-img src="" alt=""></div>
          <div class="rlb__body">
            <div class="rlb__top"><span data-rlb-stars></span><span class="verified" data-rlb-verified>${document.querySelector('.verified') ? document.querySelector('.verified').innerHTML : 'Verified buyer'}</span></div>
            <h3 data-rlb-title></h3>
            <p data-rlb-text></p>
            <footer><span class="avatar" data-rlb-avatar></span><div><strong data-rlb-name></strong><span data-rlb-meta></span></div></footer>
          </div>
        </div>
        <button type="button" class="rlb__arrow rlb__arrow--next" data-rlb-next aria-label="Next photo">${svgArrow(false)}</button>
        <p class="rlb__counter" data-rlb-counter></p>`;
      document.body.appendChild(lb);
      lb.addEventListener('click', (e) => { if (!e.target.closest('[data-rlb-panel], [data-rlb-prev], [data-rlb-next]')) close(); });
      $('[data-rlb-close]', lb).addEventListener('click', close);
      $('[data-rlb-prev]', lb).addEventListener('click', () => show(idx - 1));
      $('[data-rlb-next]', lb).addEventListener('click', () => show(idx + 1));
      document.addEventListener('keydown', (e) => {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(idx - 1);
        else if (e.key === 'ArrowRight') show(idx + 1);
      });
      /* swipe on touch */
      let x0 = null;
      lb.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
      });
      return lb;
    };

    const show = (i) => {
      if (!items.length) return;
      idx = (i + items.length) % items.length;
      const it = items[idx];
      const img = $('[data-rlb-img]', lb);
      img.src = it.full || it.thumb; img.alt = it.alt || it.name;
      $('[data-rlb-stars]', lb).innerHTML = it.stars;
      $('[data-rlb-verified]', lb).hidden = !it.verified;
      const t = $('[data-rlb-title]', lb); t.textContent = it.title; t.hidden = !it.title;
      const p = $('[data-rlb-text]', lb); p.textContent = it.text; p.hidden = !it.text;
      $('[data-rlb-avatar]', lb).textContent = it.name.trim().slice(0, 2).toUpperCase();
      $('[data-rlb-name]', lb).textContent = it.name;
      $('[data-rlb-meta]', lb).textContent = it.meta;
      $('[data-rlb-counter]', lb).textContent = `${idx + 1} / ${items.length}`;
      const one = items.length < 2;
      $('[data-rlb-prev]', lb).hidden = one; $('[data-rlb-next]', lb).hidden = one;
      /* preload neighbours */
      [idx + 1, idx - 1].forEach((n) => { const nb = items[(n + items.length) % items.length]; if (nb && nb.full) { const pre = new Image(); pre.src = nb.full; } });
    };

    const open = (list, i) => {
      items = list; ensureLightbox();
      lastFocus = document.activeElement;
      lb.hidden = false; document.documentElement.classList.add('rlb-open');
      show(i);
      requestAnimationFrame(() => { lb.classList.add('is-open'); $('[data-rlb-close]', lb).focus(); });
    };

    const close = () => {
      if (!lb || lb.hidden) return;
      lb.classList.remove('is-open'); document.documentElement.classList.remove('rlb-open');
      setTimeout(() => { lb.hidden = true; }, reduce ? 0 : 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    /* Build (or rebuild) the strip inside one reviews section from its review cards. */
    const lists = new WeakMap();
    const build = (root) => {
      const strip = $('[data-review-photos]', root);
      const cards = $$('[data-review][data-photo]', root).filter((c) => c.querySelector('.review__photo'));
      const list = cards.map(infoOf).filter((it) => it.thumb);
      lists.set(root, list);
      /* Card photos open the same viewer even when the strip is turned off. */
      cards.forEach((c) => {
        const btn = c.querySelector('[data-review-photo]');
        if (btn && !btn.dataset.bound) {
          btn.dataset.bound = '1';
          btn.addEventListener('click', () => { const cur = lists.get(root) || list; const i = cur.findIndex((it) => it.card === c); open(cur, i < 0 ? 0 : i); });
        }
      });
      if (!strip) return;
      const track = $('[data-review-photos-track]', strip);
      const count = $('[data-review-photos-count]', strip);
      const prev = $('[data-photos-prev]', strip), next = $('[data-photos-next]', strip);
      track.innerHTML = '';
      strip.hidden = list.length === 0;
      if (!list.length) return;
      if (count) count.textContent = `(${list.length.toLocaleString('en-IN')})`;
      list.forEach((it, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'review-photos__item';
        b.setAttribute('aria-label', `Photo ${i + 1} of ${list.length} by ${it.name}`);
        b.innerHTML = `<img src="${it.thumb}" alt="" loading="lazy" width="160" height="160"><span class="review-photos__stars">${it.stars}</span>`;
        b.addEventListener('click', () => open(list, i));
        track.appendChild(b);
      });
      const step = () => Math.max(160, Math.round(track.clientWidth * 0.8));
      const updateArrows = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        strip.classList.toggle('has-overflow', track.scrollWidth > track.clientWidth + 2);
      };
      if (!track.dataset.bound) {
        track.dataset.bound = '1';
        prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }));
        next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }));
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);
        track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
        });
      }
      track.scrollLeft = 0;
      requestAnimationFrame(updateArrows);
      strip.classList.add('is-in');
    };

    /* Pull the photo reviews of another page (the Reviews page and its extra page) into this section,
       so the product page strip shows its own photos first and then every photo from the full reviews list. */
    const docCache = {};
    const fetchDoc = (url) => {
      if (!docCache[url]) {
        docCache[url] = fetch(url, { credentials: 'same-origin' }).then((r) => r.ok ? r.text() : '').then((html) => html ? new DOMParser().parseFromString(html, 'text/html') : null).catch(() => null);
      }
      return docCache[url];
    };
    const samePage = (url) => { try { return new URL(url, location.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, ''); } catch (e) { return false; } };
    const dateOf = (c) => { const t = Date.parse(c.dataset.date || ''); return Number.isNaN(t) ? 0 : t; };
    const load = (root) => {
      const url = (root.dataset.photosUrl || '').trim();
      if (!url || samePage(url) || !('fetch' in window)) return;
      $$('[data-remote-photos]', root).forEach((h) => h.remove());
      fetchDoc(url).then(async (doc) => {
        if (!doc) return;
        let cards = [...doc.querySelectorAll('[data-review][data-photo]')];
        /* The reviews page may keep extra reviews on a second page: include those too. */
        const list = doc.querySelector('[data-reviews-list]');
        const more = list ? (list.dataset.moreUrl || '').trim() : '';
        if (more && !samePage(more)) {
          const doc2 = await fetchDoc(more);
          if (doc2) cards = cards.concat([...doc2.querySelectorAll('[data-review][data-photo]')]);
        }
        cards = cards.filter((c) => c.querySelector('.review__photo'));
        if (!cards.length) return;
        cards.sort((a, b) => dateOf(b) - dateOf(a));
        const holder = document.createElement('div');
        holder.className = 'reviews-batch'; holder.setAttribute('data-reviews-batch', ''); holder.setAttribute('data-remote-photos', ''); holder.hidden = true;
        cards.forEach((c) => {
          c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('data-batch'); c.dataset.remote = '1'; c.removeAttribute('hidden');
          c.querySelectorAll('img[src]').forEach((img) => { img.loading = 'lazy'; });
          holder.appendChild(document.importNode(c, true));
        });
        root.appendChild(holder);
        build(root);
      });
    };
    return { build, load, close };
  })();

  /* Featured reviews sections (product / home page) */
  try {
    const initSection = (sec) => { reviewPhotos.build(sec); reviewPhotos.load(sec); };
    $$('[data-reviews-section]').forEach(initSection);
    document.addEventListener('shopify:section:load', (e) => { $$('[data-reviews-section]', e.target).forEach(initSection); });
  } catch(e) { if (console && console.error) console.error('Review photos error:', e); }

  /* ---------- All reviews: merge batches, filter, paginate ---------- */
  try {
    const list = $('[data-reviews-list]');
    if (list) {
      const grid = $('[data-reviews-grid]', list);
      const pager = $('[data-reviews-pager]', list);
      const empty = $('[data-reviews-empty]', list);
      const summary = $('[data-reviews-summary]', list);
      const filters = $('[data-reviews-filters]', list);
      const perPage = Math.max(1, Number(list.dataset.perPage) || 24);
      const displayCount = Number(list.dataset.displayCount) || 0;
      const displayPretty = list.dataset.displayPretty || '';
      const subTpl = list.dataset.sub || '';
      let filter = 'all';
      let page = Math.max(1, Number(new URLSearchParams(location.search).get('page')) || 1);
      let cards = [];

      const fmt = (n) => Number(n).toLocaleString('en-IN');
      const dateOf = (c) => { const t = Date.parse(c.dataset.date || ''); return Number.isNaN(t) ? 0 : t; };

      const gather = () => {
        /* Pull cards out of every batch section into the single grid. Cards keep their editor attributes. */
        $$('[data-reviews-batch] [data-review]').forEach((c) => grid.appendChild(c));
        cards = $$('[data-review]', grid);
        cards.sort((a, b) => dateOf(b) - dateOf(a));
        cards.forEach((c) => grid.appendChild(c));
      };

      const matches = (c) => filter === 'all' ? true : filter === 'photo' ? c.hasAttribute('data-photo') : c.dataset.rating === filter;

      const renderStats = () => {
        const total = cards.length;
        const shownTotal = displayCount || total;
        const scale = total ? shownTotal / total : 1;
        const sub = $('[data-reviews-sub]', list);
        if (sub) sub.textContent = total ? subTpl.replace('[count]', displayPretty || fmt(shownTotal)) : '';
        if (!summary) return;
        summary.hidden = total === 0;
        if (!total) return;
        const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        let sum = 0;
        cards.forEach((c) => { const r = Number(c.dataset.rating) || 0; sum += r; if (counts[r] !== undefined) counts[r] += 1; });
        const avg = (sum / total);
        const avgEl = $('[data-reviews-avg]', summary); if (avgEl) avgEl.textContent = avg.toFixed(2);
        const cnt = $('[data-reviews-count]', summary); if (cnt) cnt.textContent = `Based on ${displayPretty || fmt(shownTotal)} reviews`;
        const starsWrap = $('[data-reviews-stars] .stars', summary);
        if (starsWrap) {
          starsWrap.setAttribute('aria-label', `${avg.toFixed(2)} out of 5 stars`);
          $$('i', starsWrap).forEach((i, idx) => {
            const n = idx + 1; i.className = ''; i.style.removeProperty('--fill');
            if (n <= Math.floor(avg)) return;
            const frac = avg - Math.floor(avg);
            if (n === Math.floor(avg) + 1 && frac >= 0.05) { i.className = 'partial'; i.style.setProperty('--fill', `${Math.round(frac * 100)}%`); }
            else i.className = 'off';
          });
        }
        for (let n = 1; n <= 5; n++) {
          const fill = $(`[data-bar-fill="${n}"]`, summary), num = $(`[data-bar-count="${n}"]`, summary);
          if (fill) fill.style.setProperty('--w', `${(counts[n] * 100 / total).toFixed(1)}%`);
          if (num) num.textContent = fmt(Math.round(counts[n] * scale));
        }
        summary.classList.add('is-in');
      };

      const renderPage = (scroll) => {
        const visible = cards.filter(matches);
        const pages = Math.max(1, Math.ceil(visible.length / perPage));
        page = Math.min(Math.max(1, page), pages);
        const start = (page - 1) * perPage, end = start + perPage;
        cards.forEach((c) => { c.hidden = true; });
        visible.forEach((c, i) => { if (i >= start && i < end) { c.hidden = false; c.classList.add('is-in'); } });
        empty.hidden = visible.length > 0;
        if (filter === 'all') {
          const url = new URL(location.href);
          if (page > 1) url.searchParams.set('page', page); else url.searchParams.delete('page');
          try { history.replaceState(null, '', url); } catch (e) {}
        }
        /* pager */
        pager.innerHTML = '';
        pager.hidden = pages <= 1;
        if (pages > 1) {
          const btn = (label, target, cls = '', aria = '') => {
            const b = document.createElement('button'); b.type = 'button'; b.className = cls; b.innerHTML = label;
            if (aria) b.setAttribute('aria-label', aria);
            if (target === page) { b.classList.add('is-active'); b.setAttribute('aria-current', 'page'); }
            b.addEventListener('click', () => { page = target; renderPage(true); });
            return b;
          };
          const arrow = (flip) => `<svg class="ico${flip ? ' flip' : ''}" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`;
          if (page > 1) pager.appendChild(btn(arrow(true), page - 1, '', 'Previous page'));
          const parts = new Set([1, pages, page - 1, page, page + 1].filter((n) => n >= 1 && n <= pages));
          let last = 0;
          [...parts].sort((a, b) => a - b).forEach((n) => {
            if (n - last > 1) { const gap = document.createElement('span'); gap.textContent = '…'; pager.appendChild(gap); }
            pager.appendChild(btn(String(n), n)); last = n;
          });
          if (page < pages) pager.appendChild(btn(arrow(false), page + 1, '', 'Next page'));
        }
        if (scroll) {
          const top = (filters || grid).getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        }
      };

      const build = () => { gather(); renderStats(); renderPage(false); reviewPhotos.build(list); };
      build();

      /* Extra reviews page (Shopify caps one template at ~1,000 blocks): fetch it once and merge its cards. */
      const moreUrl = (list.dataset.moreUrl || '').trim();
      if (moreUrl && !moreUrl.split('?')[0].endsWith(location.pathname.replace(/\/$/, '')) && 'fetch' in window) {
        fetch(moreUrl, { credentials: 'same-origin' }).then((r) => r.ok ? r.text() : '').then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const remote = [...doc.querySelectorAll('[data-reviews-batch] [data-review]')];
          if (!remote.length) return;
          const holder = document.createElement('div');
          holder.className = 'reviews-batch'; holder.setAttribute('data-reviews-batch', ''); holder.dataset.remote = moreUrl;
          remote.forEach((c) => {
            c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('data-batch'); c.dataset.remote = '1';
            c.querySelectorAll('img[src]').forEach((img) => { img.loading = 'lazy'; });
            holder.appendChild(document.importNode(c, true));
          });
          list.appendChild(holder);
          build();
        }).catch(() => {});
      }

      if (filters) {
        $$('[data-filter]', filters).forEach((b) => b.addEventListener('click', () => {
          filter = b.dataset.filter; page = 1;
          $$('[data-filter]', filters).forEach((x) => x.classList.toggle('is-active', x === b));
          renderPage(false);
        }));
      }

      /* Theme editor: rebuild when a batch section is edited, and jump to a review when it is selected. */
      document.addEventListener('shopify:section:unload', (e) => {
        $$(`[data-review][data-batch="${e.detail.sectionId}"]`, grid).forEach((c) => c.remove());
      });
      document.addEventListener('shopify:section:load', (e) => {
        if ($('[data-reviews-batch]', e.target) || $('[data-reviews-list]', e.target)) build();
      });
      document.addEventListener('shopify:block:select', (e) => {
        const card = e.target && e.target.closest ? e.target.closest('[data-review]') : null;
        if (!card || !grid.contains(card)) return;
        if (!matches(card)) {
          filter = 'all';
          if (filters) $$('[data-filter]', filters).forEach((x) => x.classList.toggle('is-active', x.dataset.filter === 'all'));
        }
        const idx = cards.filter(matches).indexOf(card);
        if (idx >= 0) { page = Math.floor(idx / perPage) + 1; renderPage(false); }
        card.scrollIntoView({ block: 'center' });
      });
    }
  } catch(e) { if (console && console.error) console.error('Reviews list error:', e); }

  /* ---------- Reveal on scroll ---------- */
  const revealEls = $$('.reveal');
  const revealAll = () => $$('.reveal').forEach((el) => el.classList.add('is-in'));
  try {
    if (revealEls.length > 0) {
      if (reduce || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
        revealAll();
      } else {
        document.documentElement.classList.add('js-ready');
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        revealEls.forEach((el, i) => { el.style.transitionDelay = `${(i % 4) * 60}ms`; io.observe(el); });
        /* Safety net: reveal everything after 2.5s in case observer is late */
        setTimeout(revealAll, 2500);
      }
    }
  } catch(e) {
    document.documentElement.classList.remove('js-ready');
    revealAll();
  }

  /* Theme editor: keep newly added sections visible */
  document.addEventListener('shopify:section:load', revealAll);
  document.addEventListener('shopify:block:select', revealAll);

  /* ---------- Count-up ---------- */
  try {
    $$('[data-count]').forEach((counter) => {
      if (reduce || !('IntersectionObserver' in window)) return;
      const target = Number(counter.dataset.count), dec = Number(counter.dataset.decimals || 0);
      if (Number.isNaN(target)) return;
      new IntersectionObserver(([e], obs) => {
        if (!e.isIntersecting) return; obs.disconnect();
        const start = performance.now(), dur = 1100;
        const tick = (t) => {
          const p = Math.min(1, (t - start) / dur), ease = 1 - Math.pow(1 - p, 3);
          counter.textContent = (target * ease).toFixed(dec);
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.4 }).observe(counter);
    });
  } catch(e) {}
})();
